import React, {ReactElement, useState} from "react";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "@/shared/StyledComponents";
import {DW_XS, PD_LG, PD_XLG, SZ_LG, SZ_SM, SZ_SMD} from "@/shared/dimens";
import {Button, Card, Grid, ThemeProvider, Typography} from "@mui/material";
import {CloseOutlined, MicOutlined, SettingsOutlined, VideocamOffOutlined} from "@mui/icons-material";
import {
  BaseChatThreadFragment,
  BaseChatThreadFragmentProps,
  BaseChatThreadFragmentState
} from "../BaseChatThreadFragment";
import {colorRed} from "@/shared/colors";
import {UserProfilePhoto} from "@/shared/types";
import {BaseApp} from "@/shared/BaseApp";
import {playRingtone, stopRingtone} from "./call_utils";

export type AudioCallDialogFragmentProps = BaseChatThreadFragmentProps & {
  onClose: () => void,
}

type AudioCallDialogFragmentState = BaseChatThreadFragmentState & {}

function AudioCallControls(props: {
  onError?: (reason: string) => void,
}): ReactElement {
  const [mediaRecorder, setMediaRecorder] = useState<MediaRecorder>();
  return <StyledBoxColumn style={{height: SZ_LG, justifyContent:"center"}}>
    {!mediaRecorder
      ? <Button
        style={{alignSelf: "center"}}
        onClick={() => {
          const constraints = {audio: true};
          navigator.mediaDevices.getUserMedia(constraints).then((value: MediaStream) => {
            setMediaRecorder(new MediaRecorder(value));
          }, reason => {
            props.onError(reason);
          });
        }}
        variant="outlined">Grant permission</Button>
      : <>
        {/*<AudioStreamView mediaRecorder={mediaRecorder}/>*/}
        <StyledBoxRow style={{padding: PD_XLG, alignItems: "center", justifyContent: "center"}}>
          <Button style={{minWidth: 0, width: SZ_SMD, height: SZ_SMD}}>
            <MicOutlined/>
          </Button>
          <Button style={{minWidth: 0, width: SZ_SMD, height: SZ_SMD}}>
            <VideocamOffOutlined/>
          </Button>
          <Button style={{minWidth: 0, width: SZ_SMD, height: SZ_SMD}}>
            <SettingsOutlined/>
          </Button>
          <StyledSpan/>
          <Button style={{background: colorRed, color: "white"}}>
            Leave
          </Button>
        </StyledBoxRow>
      </>}
  </StyledBoxColumn>;
}

export class AudioCallDialogFragment extends BaseChatThreadFragment<AudioCallDialogFragmentProps, AudioCallDialogFragmentState> {

  protected getIntrinsicHeight(): number | string {
    return null;
  }

  componentDidMount() {
    super.componentDidMount();
    playRingtone();
  }

  componentWillUnmount() {
    stopRingtone();
    super.componentWillUnmount();
  }

  renderContent(): ReactElement {
    let theme = BaseApp.CONTEXT.getAppConfig().theme;
    return <ThemeProvider theme={theme}>
      <div style={{display: "flex", flexDirection: "column", width: 400, background: theme.palette.background.paper}}>
        <StyledBoxRow style={{cursor: "default", zIndex: 1, width: "100%", height: SZ_SM, alignItems: "center"}}>
          <Typography
            style={{
              whiteSpace: "nowrap",
              overflowX: "hidden",
              textOverflow: "ellipsis",
              maxWidth: DW_XS,
              paddingLeft: PD_LG,
              paddingRight: PD_LG,
              color: theme.palette.text.primary
            }}
            variant="h6">
            {this.props.thread.getDisplayName()}
          </Typography>
          <StyledSpan/>
          <Button
            onClick={() => this.props.onClose()}
            style={{minWidth: 0, width: 48, height: 48}}>
            <CloseOutlined/>
          </Button>
        </StyledBoxRow>
        <StyledBoxColumn>
          <Grid container style={{padding: PD_XLG, alignSelf: "center"}}>
            {this.state.participants.map(participant => <Grid item xs={this.state.participants.length === 2 ? 6 : 4}>
              <div style={{display: "flex", justifyContent: "center", width: "100%"}}>
                <Card style={{width: SZ_LG, aspectRatio: 1, alignSelf: "center"}}>
                  <img src={participant.getMetadata().profilePhoto}
                       style={{width: "100%", height: "100%", objectFit: "cover"}}/>
                </Card>
              </div>
            </Grid>)}
          </Grid>
          <AudioCallControls />
        </StyledBoxColumn>
      </div>
    </ThemeProvider>;
  }
}